import { Controller } from "react-hook-form";
import Select from "react-select";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";

interface SFTCProps {
  name: string;
  control: any;
  optionList: any[];
  placeholder?: string;
  className?: string;
  errors?: any;
  required?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  tabIndex?: number;
  selectedOption?: any;
  setSelectedOption?: (data: any) => void;
}
export default function SelectFormTagControl(props: SFTCProps) {
  const {
    control,
    optionList,
    placeholder,
    name,
    errors,
    required = false,
    isSearchable = false,
    isClearable = false,
    tabIndex,
    selectedOption,
    setSelectedOption
  } = props;
  let inputClassName = "border-none control-search";
  if (errors) {
    inputClassName += " border-danger";
  }
  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{
          ...(required && { required: { value: true, message: REQ_ERR_MSG } }),
        }}
        render={({ field: { onChange, value } }) => (
          <Select 
            tabIndex={tabIndex}
            options={optionList}
            placeholder={placeholder}
            // value={optionList.find((option) => option.value === value)}
            value={selectedOption}
            className={inputClassName}
            classNamePrefix='rs'
          onChange={(itm) => {
            onChange(itm ? itm.value : "");
            if (setSelectedOption) {
              setSelectedOption(itm);
            }
          }}
            isSearchable={isSearchable}
            isClearable={isClearable}
            defaultValue={selectedOption}
            //menuIsOpen={true}
            formatOptionLabel={({ label, desc, isDisabled }) => (
              <>
                <div className="d-flex">
                  {isDisabled === true ? (
                    <>
                      <div className="col select-form-tag-header">{label}</div>
                      <div className="col select-form-tag-header">{desc}</div>
                    </>
                  ) : (
                    <>
                      <div className="col">{label}</div>
                      <div className="col">{desc}</div>
                    </>
                  )}
                </div>
              </>
            )}
          />
        )}
      />
      {errors && (
        <div>
          <span className="text-danger">{errors.message}</span>
        </div>
      )}
    </>
  );
}
